import api from '@/api';

export const getters = {
  lastUpdatedAt: state => state.lastUpdatedAt,
};

export const actions = {
  FETCH_LAST_UPDATED_AT: ({ commit }) => {
    return new Promise(resolve => {
      api.fetchLastUpdatedAt().then(({ last_updated }) => {
        commit('SET_LAST_UPDATED_AT', { date: last_updated });
        resolve(last_updated);
      });
    });
  },
};

export const mutations = {
  SET_LAST_UPDATED_AT(state, { date }) {
    state.lastUpdatedAt = date;
  },
};

const state = {
  lastUpdatedAt: null,
};

export default {
  state,
  actions,
  getters,
  mutations,
};
